import styled from 'styled-components';
import { black, exactWhite, lightGray } from '../../utils/style/colors';

interface INavigationProps {
  isActive: boolean;
}

interface INavigationOverlayProps {
  index: number;
  count: number;
}

interface INavigationTitleProps {
  isCenter: boolean;
}

const ITEM_HEIGHT = 2.1;
const ITEM_WIDTH = 100;
const NAVIGATION_COLOR = '#00897b';
const NAVIGATION_HEIGHT = 3;
const NAVIGATION_PADDING = 0.5;

export const NavigationTitleWrapper = styled('div')<INavigationTitleProps>`
  align-items: center;
  color: ${black};
  display: inline-flex;
  overflow: hidden;
  &:hover {
    overflow: initial;
  }
  //flex: 1;
  font-size: 1.2rem;
  font-weight: 400;
  justify-content: ${(props) => (props.isCenter ? 'center' : 'flex-start')};
  height: ${NAVIGATION_HEIGHT}rem;
  // overflow: visible;
  padding: 0 0.5rem;
  transition: all 0.3s;
`;

export const NavigationTitle = styled('span')`
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  white-space: nowrap;
  font-weight: bold;
`;

export const NavigationItem = styled('li')<INavigationProps>`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  height: ${ITEM_HEIGHT}rem;
  justify-content: center;
  position: relative;
  transition: 0.3s ease;
  min-width: 5rem;
  margin: 0.25rem;
  z-index: 2;
  background-color: transparent;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
  ${({ isActive }) =>
    isActive &&
    `
        & > ${NavigationLabel} {
            color: var(--exact-white);
            background-color: ${black};
        }
    `}
`;

export const MenuIcon = styled('label')`
  cursor: pointer;
  float: left;
  padding: calc(${NAVIGATION_HEIGHT}rem / 2) ${NAVIGATION_PADDING}rem;
  position: relative;
  user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
  ::before {
    content: none !important;
  }
`;

export const NavigationItemsList = styled('ul')`
  align-items: center;
  clear: both;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  flex-shrink: 0;
  list-style: none;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-out;
  /* list of items on small screen */
  left: 0;
  position: absolute;
  top: ${NAVIGATION_HEIGHT}rem;
  width: 100%;
  margin: 0;
  background-color: ${exactWhite};
  flex-wrap: wrap;
`;

export const NavigationLabel = styled('span')`
  color: ${black};
  border: 1px solid ${black};
  padding: 0.25rem 0.5rem;
  border-radius: 0.5rem;
  display: block;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
  transition-duration: 0.3s;
  user-select: none;
  width: 100%;
  text-align: center;
`;

export const NavigationIcon = styled('span')`
  background: ${black};
  display: block;
  height: 2px;
  position: relative;
  transition: background 0.2s ease-out;
  width: 18px;
  ::before {
    top: 5px;
  }
  ::after {
    top: -5px;
  }
  ::before,
  ::after {
    background: ${black};
    content: '';
    display: block;
    height: 100%;
    position: absolute;
    transition: all 0.2s ease-out;
    width: 100%;
  }
`;

export const CloseIconWrapper = styled('div')`
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  height: 1.8rem;
  justify-content: center;
  flex-wrap: nowrap;
  min-width: 1.8rem;
  vertical-align: middle;
  width: 1.8rem;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
  & > i {
    color: ${black};
    font-size: 1.3rem;
  }
  @media only screen and (max-width: 768px) {
    margin-right: 0rem;
  }
`;

export const CloseIcon = styled('span')`
  background: transparent;
  display: inline-block;
  height: 2px;
  position: relative;
  transition: background 0.2s ease-out;
  vertical-align: middle;
  width: 18px;
  ::before {
    transform: rotate(-45deg);
  }
  ::after {
    transform: rotate(45deg);
  }
  ::before,
  ::after {
    background: ${NAVIGATION_COLOR};
    content: '';
    display: block;
    height: 100%;
    position: absolute;
    transition: all 0.2s ease-out;
    width: 100%;
  }
`;

export const NavigationItemWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  z-index: 1000;
`;

export const MenuButton = styled('input')`
  display: none;
  :checked {
    ~ ${NavigationItemsList} {
      max-height: 240px;
    }
    ~ ${MenuIcon} ${NavigationIcon} {
      background: transparent;
      ::before {
        transform: rotate(45deg);
      }
      ::after {
        transform: rotate(-45deg);
      }
    }

    ~ ${MenuIcon}:not(.stpes) ${NavigationIcon} {
      ::after {
        left: -1px;
        top: 0;
        width: 70%;
      }
      ::before {
        right: -1.5px;
        top: 0;
        width: 70%;
      }
    }
  }
`;

export const NavigationOverlay = styled('div')<INavigationOverlayProps>`
  background-color: ${lightGray};
  border-radius: 2rem;
  height: ${ITEM_HEIGHT}rem;
  position: absolute;
  transition: 0.3s ease;
  width: ${ITEM_WIDTH}px;
  @media only screen and (min-width: 768px) {
    right: ${(props) => `${props.index * ITEM_WIDTH}px`};
  }

  @media only screen and (max-width: 768px) {
    top: ${(props) => `${(props.count - props.index - 1) * ITEM_HEIGHT}rem`};
    // border-radius: unset;
    width: 80%;
  }
`;

export const NavigationHeader = styled('header')`
  display: flex;
  align-items: center;
  min-height: ${NAVIGATION_HEIGHT}rem;
  width: 100%;
  z-index: 999;
  padding: 0.5rem;

  @media only screen and (min-width: 768px) {
    padding: 0 ${NAVIGATION_PADDING}rem;

    & > ${CloseIconWrapper} {
      margin-right: 0;
    }

    & > ${NavigationItemWrapper} {
      & > ${NavigationItem} {
        float: left;
        & > span {
          padding: 30px 0;
        }
      }
      & > ${NavigationItemsList} {
        position: relative;
        top: unset;
        width: 100%;
        clear: none;
        flex-direction: row;
        float: left;
        height: ${NAVIGATION_HEIGHT}rem;
        max-height: none;
      }
      & > ${MenuIcon} {
        display: none;
      }
    }
  }
`;

export const SelectTagContainer = styled('div')`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 200px;
  margin: 0 0.5rem;
  font-size: 1rem;
  justify-content: flex-end;
`;

export const AnimationHandler = styled('div')`
  display: flex;
  background: ${black};
  color: var(--exact-white);
  border-radius: 0.5rem;
  justify-content: space-around;
  align-items: center;
  max-width: 5rem;
  height: 80%;
  margin: 0.25rem 0;
`;
